/**
 *  Returns main config
 * @type {{cardinalCruise: string, apiEndpoint: string, captchaSiteKey: string, captchaURL: string, isEnabledCaptcha: string}}
 */
export const config = {
  apiEndpoint: '__API-URL__',
  baseURL: '__BASE-URL__',
  devCardinalCruise:
    'https://songbirdstag.cardinalcommerce.com/edge/v1/songbird.js',
  ddcCardinalCruise: '__DDC_CARDINAL_URL__',
  apexxPublicKey: '__APEXX-PUBLIC-KEY__',
  googlePayURL: 'https://pay.google.com/gp/p/js/pay.js',
  googlePayEnv: '__GOOGLE-PAY-ENV__',
  applePayURL: 'https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js',
  datadogProxyUrl: '__DATADOG-PROXY-URL__',
  datadogClientToken: '__DATADOG-CLIENT-TOKEN__',
  env: '__ENV__',
  version: '__VERSION__',
  recaptchaSiteKey: '__RECAPTCHA_PUBLIC_KEY__',
  evervaultTeamId: '__EV_TEAM_UUID__',
  evervaultAppId: '__EV_APP_UUID__',
  /*
   * todo:
   * 1. may be taken from the env variables
   * 2. need to sync with package.json config l10n section
   */
  locales: ['en-GB', 'nl-NL'],
  cardinalCruiseResourcesTimeout: 45,
  DETAILS_IFRAME_URL: '__DETAILS-IFRAME-URL__',
}
